import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useEffect } from 'react';
import { memoGeneric } from '@/js/libs/memo';
import { Checkbox } from '../../../../Form/Checkbox';
import { Label, OptionWrapper } from './styled';
export const OptionCheckbox = memoGeneric(function OptionCheckbox({ option, checked, isFocused = false, onClick, formatOptionLabel, }) {
    const label = useMemo(() => (formatOptionLabel ? formatOptionLabel(option) : option.label), [formatOptionLabel, option]);
    const ref = useRef(null);
    // Scroll into view when focused
    useEffect(() => {
        if (isFocused && ref.current) {
            ref.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }, [isFocused]);
    return (_jsxs(OptionWrapper, { onClick: onClick, $isFocused: isFocused, ref: ref, "data-testid": 'option-checkbox', children: [_jsx(Checkbox, { checked: checked, onChange: onClick }), _jsx(Label, { "data-testid": 'option-label', children: label })] }));
});
